
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
import { 
    getNativeCoinBalance,
    onAccountAvailable,
    bootstrap,
    shutdown,
    coinConvert
} from '@stakeordie/griptape.js'
import { EventCallback } from "@stakeordie/griptape.js"

export default defineComponent({
    setup() {
        const balance = ref<string | undefined>();
        const loading = ref<boolean>(false);
        const isConnected = ref<boolean>(false);

        async function getBalance() {
            loading.value = true;
            const result = await getNativeCoinBalance();
            balance.value = result;
            loading.value = false;
        }

        function disconnect() {
            shutdown();
            isConnected.value = false;
        }

        let stopListen: EventCallback | undefined;
        onMounted(() => {
            stopListen = onAccountAvailable(()=> {
                isConnected.value = true;
                getBalance();
            })
        });

        onUnmounted(() => {
            if (stopListen) stopListen();
            isConnected.value = false;
        })

        return {
            coinConvert,
            bootstrap,
            disconnect,
            balance,
            loading,
            isConnected
        };
    }
});
